import {deepClone, GoingNewUtils} from 'xmgoing-utils';
import {saveUserColDataFun} from "@/main-page/hooks/useColSaveHooks";
import {useRoute} from "vue-router";
import GoingUtils from "@/utils/goingUtils";
import {createDynamicStore} from "@/store/utils/dynamicStore";
import {unref} from "vue";
import {getRecordById} from "@/main-page-base/ctls/dataCtls/xmTreeCtl/hooks/useDataDealHooks";
import eventBus from "@/events/eventBus";
import {mergeCommittedAndLayerIntoFlushParams} from "@/main-page/utils/gridQuerySyncUtils";


interface GridTableState {
  tableList: Array<any>;
  tableListRefObj: any;
  curUserTenantId: '',
  indeterList:any;
}


export const useGridTableStore = function () {
  const route = useRoute();
  let storeId = route?.meta.storeId || GoingUtils.getPageCode();
  if (storeId == null || storeId === 'undefined') {
    storeId = GoingUtils.getPageCode();
  }
  return createDynamicStore(
    {
      id: 'gridTableStore',
      name:'gridTableStore',
      state: (): GridTableState => ({
        tableList: [],
        indeterList:[],
        tableListRefObj: {},
        curUserTenantId: '',
      }),
      getters: {},
      actions: {
        claerAllCache() {
          console.error("===========gridTableStore.ts======")
          // 清理所有表格数据
          this.tableList.forEach(tableObj => {
            const key = tableObj.value;
            if (this[key]) {
              // 清理表格引用
              delete this[key];
            }
          });
          this.tableList = [];
          // 清理表格 Ref 引用
          Object.keys(this.tableListRefObj).forEach(key => {
            delete this.tableListRefObj[key];
          });
          this.tableListRefObj = {};
          this.indeterList = [];
        },
        /**
         * 获取当前租户id
         */
        getCurUserTenantId() {
          return this.curUserTenantId;
        },
        //注册表格对象
        registerCtl({props, dataConfig, ctlType = 'grid', modelKey = ''}) {
          // 在删除之前，保存 colPermissions 和 colShows（如果存在）
          const savedColPermissions = this[props.key] && this[props.key]["colPermissions"] ? {...this[props.key]["colPermissions"]} : null;
          const savedColShows = this[props.key] && this[props.key]["colShows"] ? {...this[props.key]["colShows"]} : null;

          if (this[props.key] !== null) {
            delete this[props.key];
          }
          if (this[props.key] == null) {
            this[props.key] = {};
            if (modelKey) {
              this[props.key].modelKey = modelKey;
            }
            const filterItem = this.tableList.filter((itemDb) => {
              return (itemDb.value + '') === (props.key + '');
            })[0]
            if (!filterItem) {
              const ctlObj = {
                ctlType,
                queryParams: {},
                useQueryType: unref(dataConfig)?.useQueryType,
                moduleName: dataConfig?.moduleName,
                tableCode: dataConfig?.domainCode,
                gridDataConfig: dataConfig,
                value: props.key,
                label: props.label,
                clientPagin: GoingNewUtils.parseBoolean(props.clientPagin),
                pageSize: props.pageSize,
                modelKey,
                formResetFlag: GoingNewUtils.getUUid(20),
                flushGrid: GoingNewUtils.getUUid(20)
              }
              this.tableList.push(ctlObj);
              // 恢复 colPermissions 和 colShows
              if (savedColPermissions && Object.keys(savedColPermissions).length > 0) {
                this[props.key]["colPermissions"] = savedColPermissions;
              }
              if (savedColShows && Object.keys(savedColShows).length > 0) {
                this[props.key]["colShows"] = savedColShows;
              }
              return ctlObj;
            } else {
              filterItem.gridDataConfig = dataConfig;
              filterItem.clientPagin = GoingNewUtils.parseBoolean(props.clientPagin);
              filterItem.pageSize = props.pageSize;
              if (modelKey) {
                filterItem.modelKey = modelKey;
              }
              return filterItem;
            }
          } else {
            if (modelKey) {
              this[props.key].modelKey = modelKey;
            }
            const existGridObj = this.getGridObjByKey(props.key);
            if (existGridObj) {
              existGridObj.gridDataConfig = dataConfig;
              existGridObj.clientPagin = GoingNewUtils.parseBoolean(props.clientPagin);
              existGridObj.pageSize = props.pageSize;
              if (modelKey) {
                existGridObj.modelKey = modelKey;
              }
            }
            // 已存在的情况，也要恢复 colPermissions 和 colShows
            if (savedColPermissions && Object.keys(savedColPermissions).length > 0) {
              this[props.key]["colPermissions"] = savedColPermissions;
            }
            if (savedColShows && Object.keys(savedColShows).length > 0) {
              this[props.key]["colShows"] = savedColShows;
            }
            return existGridObj || this.getGridObjByKey(props.key);
          }
        },
        /**
         * 设置查询条件参数
         */
        setQueryCache(gridKey, queryParams) {
          const tableObj = this.getGridObjByKey(gridKey);
          if (tableObj == null) {
            console.error('tableObj 为空！请确认');
            return;
          }
          if (tableObj) {
            tableObj['cacheQueryParams'] = queryParams;
          }
        },
        /**
         * 获取查询缓存
         * @param gridKey
         */
        getQueryCache(gridKey) {
          const tableObj = this.getGridObjByKey(gridKey);
          if (tableObj == null) {
            console.error('tableObj 为空！请确认');
            return;
          }
          if (tableObj) {
            return tableObj['cacheQueryParams'];
          }
        },
        /**
         * 设置排序参数
         */
        setQuerySort(gridKey, queryParams) {
          const tableObj = this.getGridObjByKey(gridKey);
          if (tableObj == null) {
            console.error('tableObj 为空！请确认');
            return;
          }
          if (tableObj) {
            tableObj['querySortParams'] = queryParams;
          }
        },
        /**
         * 获取查询缓存
         * @param gridKey
         */
        getQuerySort(gridKey) {
          const tableObj = this.getGridObjByKey(gridKey);
          if (tableObj == null) {
            console.error('tableObj 为空！请确认');
            return;
          }
          if (tableObj) {
            return tableObj['querySortParams'];
          }
        },
        addTableObjRef(gridKey, tableRefObj) {
          this.tableListRefObj[gridKey] = tableRefObj;
        },
        getGridRefObjByKey(gridKey) {
          return this.tableListRefObj[gridKey];
        },
        getGridObjByKey(key) {
          const tableObj = this.tableList.filter((tableObj) => {
            return tableObj.value === key;
          })[0];
          return tableObj;
        },
        //初始化表格记录选中Id 集合情况
        initGridRecords(key, records) {
          if (this[key]) {
            this[key]["selRecords"] = records;
          }
        },
        //初始化表格记录选中情况
        initGridRecordObjs(key, recordObjs) {
          if (this[key]) {
            this[key]["selRecordObjs"] = recordObjs.filter(obj => obj !== undefined);
          }
        },
        addSubRecords(key: string, record: any){
          if (!this[key]) {
            this[key] = {};
          }
          // 初始化indeterList数组
          if (!this[key]["subGridList"]) {
            this[key]["subGridList"] = [];
          }
          // 检查record是否已存在（根据id判断）
          const index = this[key]["subGridList"].findIndex((item: any) => item.id === record.id);
          // 如果不存在则添加
          if (index === -1) {
            this[key]["subGridList"].push(record);
          } else {
            // 如果存在则替换为新的record
            this[key]["subGridList"][index] = record;
          }
        },
        /**
         * 移除子记录信息
         * @param key
         * @param record
         */
        removeSubRecords(key: string, record: any) {
          if (this[key] && this[key]["subGridList"]) {
            const index = this[key]["subGridList"].findIndex((item: any) => item.id === record.id);
            if (index > -1) {
              this[key]["subGridList"].splice(index, 1);
            }
          }
        },
        /**
         * 获取子记录集合
         * @param key
         * @param record
         */
        getSubRecords(key: string) {
          return this[key]["subGridList"];
        },
        addIndeterList(key: string, record: any) {
          if (!this[key]) {
            this[key] = {};
          }
          // 初始化indeterList数组
          if (!this[key]["indeterList"]) {
            this[key]["indeterList"] = [];
          }
          // 检查record是否已存在（根据id判断）
          const index = this[key]["indeterList"].findIndex((item: any) => item.id === record.id);
          // 如果不存在则添加
          if (index === -1) {
            this[key]["indeterList"].push(record);
          } else {
            // 如果存在则替换为新的record
            this[key]["indeterList"][index] = record;
          }
        },
        removeIndeterList(key: string, record: any) {
          if (this[key] && this[key]["indeterList"]) {
            const index = this[key]["indeterList"].findIndex((item: any) => item.id === record.id);
            if (index > -1) {
              this[key]["indeterList"].splice(index, 1);
            }
          }
        },
        getIndeterList(key: string) {
          if (this[key] && this[key]["indeterList"]) {
            return this[key]["indeterList"];
          }
          return [];
        },
        flushSelRecords(listRecords,gridKey){
          if(this[gridKey]["selRecordObjs"]&&Array.isArray(this[gridKey]["selRecordObjs"])&&this[gridKey]["selRecordObjs"].length>0){
            this[gridKey]["selRecordObjs"].forEach((recordTemp,index)=>{
              const findRecord={target:null}
              getRecordById(unref(listRecords),unref(recordTemp)['id'],findRecord);
              if(findRecord.target){
                this[gridKey]["selRecordObjs"][index]=findRecord.target;
              }
            })
          }
        },
        //获取表格选中的记录集合
        getGridSels(key) {
          return (this[key] && this[key]["selRecords"]) || [];
        },
        //获取表格选中的记录集合
        getRecordObjs(key) {
          if (this[key]) {
            if (this[key]["selRecordObjs"] && Array.isArray(this[key]["selRecordObjs"])) {
              return this[key]["selRecordObjs"].filter(obj => obj !== undefined);
            }
          }
          return [];
        },
        clearGridSels(key) {

          if (key) {
            if (this[key]) {
              this[key]["selRecords"] = [];
              this[key]["selRecordObjs"] = [];
            }
          }
        },
        //获取表格的查询参数
        getGridQueryParams(key) {
          return this[key] && this[key]["queryParams"] || {};
        },
        //设置表格记录总数
        setTotalVal(key, totalCount) {
          if(this[key]){
            this[key]["totalRecords"] = totalCount;
          }
        },
        getGridTotal(key) {
          return (this[key] && this[key]["totalRecords"]) || 0;
        },
        formResetFields(key) {
          const tableObj = this.getGridObjByKey(key);
          if (tableObj == null) {
            console.error('tableObj 为空！请确认');
            return;
          }
          tableObj['formResetFlag'] = "formResetFields_" + GoingNewUtils.getUUid(20);
        },
        //根据filter标签进行查询（请改用 gridQuerySyncUtils.applyOrLayerQueryPatch / applyAndLayerFromTag）
        flushGridByFilter(key, filterParams, initCurrent = false, extendParams = false, queryUserParams = []) {
          console.warn('[gridTableStore] flushGridByFilter is deprecated; use applyOrLayerQueryPatch / applyAndLayerFromTag');
        },
        setCommittedColQueryParams(key, params) {
          const tableObj = this.getGridObjByKey(key);
          if (tableObj) {
            tableObj.committedColQueryParams = deepClone(params || {});
          }
        },
        setCommittedMoreQueryConfigs(key, configs) {
          const tableObj = this.getGridObjByKey(key);
          if (tableObj) {
            tableObj.committedMoreQueryConfigs = configs ? deepClone(configs) : null;
          }
        },
        //清空数据
        clearCtlDate(key) {
          const tableObj = this.getGridObjByKey(key);
          tableObj['clearCtlDate'] = GoingNewUtils.getUUid(20);
        },
        //刷新表格
        flushGrid(key, params, initCurrent = false, extendParams = false, paramsRel = '', clearSelRecord = false, userUrl = '') {
          if (clearSelRecord) {
            this.clearGridSels(key);
          }
          const tableObj = this.getGridObjByKey(key);
          if (tableObj == null) {
            eventBus.emit(key + '_flushCtlData', {});
            console.error('tableObj 为空！请确认');
            return;
          }
          if (params) {
            if (!extendParams) {
                // 不继承参数时 移除空属性
                Object.keys(params).forEach((propName) => {
                    if (params[propName] == null || params[propName] === "") {
                        delete params[propName];
                    }
                })
            }
            // 查询表单 echo=form：页面脚本若只用表单值刷新，只读补回已提交的列头条件
            params = mergeCommittedAndLayerIntoFlushParams(key, params, this, {extendParams, paramsRel});
            tableObj.queryParams = deepClone(params);
          } else {
            tableObj.queryParams = {};
          }
          // 继承刷新（extendParams=true）时，页面脚本常把第 5 参默认写成 'and'（保存后刷新、关抽屉等），
          // 这表示「保持当前条件再查」，不是切查询层。当前已是 OR 时不得改成 AND，否则标签关键字或查询
          // 会被改成且，并同步到表头。
          // 若要在 OR 之后切到 AND：应 extendParams=false 并只传新的 AND 参数（四入口内部切层也是如此）。
          // 暂不支持「继承旧 OR 参数 + 追加新参数 + paramsRel=and」这种叠层写法。
          if (paramsRel) {
            const preserveOrLayer = extendParams && tableObj.paramsRel === 'or' && paramsRel === 'and';
            if (!preserveOrLayer) {
              tableObj.paramsRel = paramsRel;
            }
          }

          if (userUrl) {
            tableObj['userUrl'] = unref(userUrl);
          }
          tableObj['flushGrid'] = `${clearSelRecord ? 'clearSelRecord_' : ''}${initCurrent ? 'initCurrent_' : ''}${extendParams ? 'extendParams_' : ''}${GoingNewUtils.getUUid(20)}`;
        },
        //改变表格的行高
        changeGridRowHeight(gridKey, inParams) {
          const tableObj = this.getGridObjByKey(gridKey);
          if (tableObj) {
            tableObj['rowHeight'] = inParams;
          }
        },
        //获取列表到cols信息
        getGridCols(key) {
          if (this[key] && this[key]["cols"]) {
            return this[key]["cols"];
          }
          return [];
        },
        //保存列配置信息
        saveColConfigs(key, flushCols = false) {
          const tableObj = this.getGridObjByKey(key);
          nextTick(() => {
            if (this[key]["cols"]) {
              saveUserColDataFun(this[key]["cols"], {key: unref(key)}, () => {
                if (flushCols) {
                  tableObj['flushCols'] = GoingNewUtils.getUUid(20);
                }
              })
            }
          })
        },
        //表格选择标志
        setGridSelFlag(key,multiple){
          const tableObj = this.getGridObjByKey(key);
          tableObj.multiple=multiple;
        },
        //设置表格的列信息
        initCtlCols(key, cols, forceUpdate = false) {
          if (this[key]) {
            // forceUpdate=true 时强制更新，否则只在第一次设置
            if (forceUpdate || !this[key]["cols"]) {
              this[key]["cols"] = cols;
            }
          }
        },
        //存储列权限设置（用于在组件创建前设置权限）
        setColPermission(key, fieldList, permission) {
          // 确保 this[key] 存在
          if (!this[key]) {
            this[key] = {};
          }
          // 确保 colPermissions 存在（不覆盖已有的）
          if (!this[key]["colPermissions"]) {
            this[key]["colPermissions"] = {};
          }
          const list = Array.isArray(fieldList) ? fieldList : (typeof fieldList === 'string' ? fieldList.split(";") : []);
          list.forEach((fieldId) => {
            this[key]["colPermissions"][fieldId] = permission;
          });
        },
        //获取列权限设置
        getColPermissions(key) {
          if (this[key] && this[key]["colPermissions"]) {
            return this[key]["colPermissions"];
          }
          return {};
        },
        //清除列权限设置
        clearColPermissions(key) {
          if (this[key]) {
            this[key]["colPermissions"] = {};
          }
        },
        //存储列显示/隐藏设置（用于在组件创建前设置显示状态）
        setColShow(key, fieldList, showFlag) {
          // 确保 this[key] 存在
          if (!this[key]) {
            this[key] = {};
          }
          // 确保 colShows 存在（不覆盖已有的）
          if (!this[key]["colShows"]) {
            this[key]["colShows"] = {};
          }
          const list = Array.isArray(fieldList) ? fieldList : (typeof fieldList === 'string' ? fieldList.split(";") : []);
          list.forEach((fieldId) => {
            this[key]["colShows"][fieldId] = showFlag;
          });
        },
        //获取列显示/隐藏设置
        getColShows(key) {
          if (this[key] && this[key]["colShows"]) {
            return this[key]["colShows"];
          }
          return {};
        },
        //清除列显示/隐藏设置
        clearColShows(key) {
          if (this[key]) {
            this[key]["colShows"] = {};
          }
        }
      },
    },
    'GridTable' + storeId
  )
}

